import React from "react";

import Contact from "../../template/Contact";

export default () => {
  return (
    <Contact
      title="Fale conosco"
      subtitle="Entre em contato com a gente através do nosso serviço de atendimento"
    />
  );
};
